import axios from 'axios';

import { Topic } from '../models/topic';
import { Option } from '../models/option';

class TopicWebservice {

    public async getAllTopics(): Promise<Topic[]> {
        return await axios.get('/topic').then(function(response) {
            const topics: Topic[] = response.data;
            return Promise.resolve(topics);
        }).catch(function(error) {
            return Promise.reject([]);
        });
    }
}

export const topicWebservice = new TopicWebservice();
